module.exports = __webpack_public_path__ + "static/img/14.81cc187.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/3/1/sp/14.png
// module id = bQ10
// module chunks = 0